import { Trans } from '@lingui/react/macro';
import { WarningBlock } from 'ui-kit';
import cls from './DemoAccessHint.module.scss';

const HINT_COLOR = '#cfe2fb';

export function DemoAccessHint() {
  return (
    <WarningBlock color={HINT_COLOR} className={cls.demoHint}>
      <Trans>
        Внимание! Это демонстрационный аккаунт.{' '}
        <i>
          Все адреса и суммы продаж вымышлены, любые совпадения с реальными
          адресами случайны
        </i>
      </Trans>
    </WarningBlock>
  );
}
